export const cornerStyleForTrait = (frameStyleData, cornerTrait) => {
  if (frameStyleData.corners.length === 1) {
    return frameStyleData.corners[0]
  }
  return frameStyleData.corners[cornerTrait % frameStyleData.corners.length]
}
